/// <reference path="../../_ext/Bases/TransDialog.ts" />

namespace TabAurous.Purchase {


    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class OrderDialog extends _Ext.TransDialog<OrderRow, any> {

        protected getFormKey() { return OrderForm.formKey; }
        protected getIdProperty() { return OrderRow.idProperty; }
        protected getLocalTextPrefix() { return OrderRow.localTextPrefix; }
        protected getNameProperty() { return OrderRow.nameProperty; }
        protected getService() { return OrderService.baseUrl; }
        protected getDeletePermission() { return OrderRow.deletePermission; }
        protected getInsertPermission() { return OrderRow.insertPermission; }
        protected getUpdatePermission() { return OrderRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new OrderForm(this.idPrefix);
        // #region Variables
        TaxRegistred: number;
        TaxArray: any[];
        public Closing: boolean = true;
        static image: string;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public CurrencyId: number;

        // #endregion
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            // #region UI
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.ExchRate);
            q.setTextRightAlign(this.form.NetWeight);
            q.setGridEditorHeight(this.form.ItemDetails, 290);
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            q.hideCaption(this.form.LedgerName);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.ShipmentId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });
            this.CurrencyId = Q.Authorization.userDefinition.CurrencyId;

            // **** Get Party Details using PartyID **** 
            this.form.PartyId.changeSelect2(e => {
                if (this.form.PartyId.value != "") {

                    let PartyDetails;
                    OMS.VendorService.Retrieve({
                        EntityId: parseInt(this.form.PartyId.value)
                    }, response => {
                        PartyDetails = response.Entity
                    }, { async: false });
                    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                    this.form.LedgerName.value = PartyDetails.LedgerName;

                    this.TaxRegistred = parseInt(PartyDetails.TaxRegType);
                    if (PartyDetails.CurrencyId > 0) {
                        this.form.CurrencyId.value = PartyDetails.CurrencyId.toString();
                        this.SetAmountFields(PartyDetails.CurrencyId);
                    }
                    else
                        this.form.CurrencyId.value = this.CurrencyId.toString();

                    this.form.GstVat.value = PartyDetails.GstVat;
                    let AddressDetails: OMS.AddressMasterRow;
                    OMS.AddressMasterService.GetAddress({
                        LedgerId: parseInt(this.form.PartyId.value)
                    },
                        response =>
                            AddressDetails = response.Entity,
                        { async: false }
                    );

                    if (AddressDetails != null) {
                        this.form.State.value = AddressDetails.StateName;
                        this.form.Country.value = AddressDetails.CountryName;
                        var city = AddressDetails.CityName;
                        let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                            + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                        this.form.Address1.value = address;

                    }
                    this.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                    this.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                    this.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                    this.StoneDiscount = PartyDetails.StnAddDisc == null ? 0 : PartyDetails.StnAddDisc;
                    this.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                    this.LaborDiscount = PartyDetails.LbrAddDisc == null ? 0 : PartyDetails.LbrAddDisc;
                    var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                    this.form.ExchRate.value = ExchangeDetails.ExchRate;
                    this.ExchangeRate = this.form.ExchRate.value;

                }
                else {
                    this.form.LedgerName.value = this.form.Address1.value = this.form.State.value = this.form.GstVat.value = this.form.Country.value = "";
                }

            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
                this.ExchangeRate = ExchangeDetails.ExchRate;
                this.SetAmountFields(parseInt(this.form.CurrencyId.value))
            });

            this.form.ExchRate.changeSelect2(e => {
                this.ExchangeRate = this.form.ExchRate.value;
            });



            //Load Image after Row in Details is Clicked
            var _this = this;
            this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {

                var x: Serenity.UploadedFile = {
                    Filename: PurchaseMasterDialog.image,
                    OriginalName: ""
                }
                _this.form.ProductItemImage.value = x;//POSSalesDialog.image;

                //Set Image Width & Height

                q.setImageEditorHeight(_this.form.ProductItemImage, 160);
            });

            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getTotalRows();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, TotalItems);

            });

            this.form.GrossAmount.addValidationRule(this.uniqueName, x => {
                var items = this.form.ItemDetails.getItems();

                items.forEach(function (value) {
                    value.BOMDetails.forEach(function (bom) {
                        if (bom.BomAmount == null || bom.BomAmount <= 0) {
                            return "BOM must Have rate!!";
                        }

                    })
                    if (value.LaborDetails!=undefined&&value.LaborDetails.length > 0) {
                        value.LaborDetails.forEach(function (bom) {
                            if (bom.LabourAmount == null || bom.LabourAmount == 0) {
                                return "Labor must Have rate!!";
                            }

                        })
                    }
                })

                if (items.length <= 0)
                    return "Select at least one item";

            });

            this.form.TransDate.addValidationRule(this.uniqueName, x => {
                var isDateEditable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.entity.VoucherTypeId)[0];
                if (isDateEditable.AllowBackDatedEntry) {
                    var StartDate = OMS.FinancialYearRow.getLookup().itemById[Q.Authorization.userDefinition.FinancialYearId].FromDate;
                    var EndDate = OMS.FinancialYearRow.getLookup().itemById[Q.Authorization.userDefinition.FinancialYearId].ToDate;
                    var maxDate = new Date(EndDate);
                    var minDate = new Date(StartDate);

                    if (new Date(this.form.TransDate.value) < minDate)
                        return "Date is out of Financial Year";

                    if (new Date(this.form.TransDate.value) > maxDate)
                        return "Can not save with future Date";
                }
            });

            this.validateForm();

        }

        // #region Total Weight, Amount and TAX Calculation
        public CalculateAmountandTax(Items: any, TotalItems: number) {
            var z = this.isEditMode();

            if (!this.isEditMode()) {

                if (this.form.ItemDetails.getItems().length > 0) {

                    q.showAndDisableField(this.form.CurrencyId);
                    q.showAndDisableField(this.form.ExchRate);
                    q.showAndDisableField(this.form.PartyId);
                }
                else {
                    q.showAndEnableField(this.form.CurrencyId);
                    q.showAndEnableField(this.form.ExchRate);
                    q.showAndEnableField(this.form.PartyId);
                }

                if (parseInt(this.form.PartyId.value) > 0) {

                    var HSN = [];
                    var Amount = [];
                    var TaxDetail = [];
                    var TaxDetail = [];
                    var ItemTotal = 0;
                    var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0; var tds = 0;
                    var FCAmt = 0;
                    for (var x of Items) {
                        ntamt += x.NetAmount || 0;
                        gramt += x.GrossAmount || 0;
                        disc += x.Discount || 0;
                        pcs += x.Pieces || 0;
                        wt += x.Weight || 0;
                        nwt += x.NetWeight || 0;

                        var temp = false;
                        for (let i = 0; i < HSN.length; i++) {
                            if (HSN[i] == x.TaxCode) {
                                Amount[i] += x.GrossAmount || 0;
                                temp = true;
                            }
                        }

                        if (!temp) {
                            HSN.push(x.TaxCode);
                            Amount.push(x.GrossAmount);
                        }
                        ItemTotal++;
                    };

                    this.form.NetAmount.value = gramt;
                    this.form.Discount.value = disc;
                    var TaxAmount = 0;
                    var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

                    if (ItemTotal == TotalItems && TaxApplicable) {
                        this.form.GrossAmount.value = gramt + TaxAmount;
                        this.form.Pieces.value = pcs;
                        this.form.Weight.value = wt;
                        this.form.NetWeight.value = nwt;
                    }
                    else {
                        this.form.GrossAmount.value = gramt;
                        this.form.Pieces.value = pcs;
                        this.form.Weight.value = wt;
                        this.form.NetWeight.value = nwt;
                    }

                    this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                    this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
                }
            }
        }

        // #endregion

        protected onDialogOpen() {
            super.onDialogOpen();
            var fieldEditor: JQuery = this.form.PartyId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();  
            if (this.form.CompanyId.value != 0 || this.form.FinancialYearId.value != 0) {
                this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            }
            if (!Q.isEmptyOrNull(this.form.PartyId.value)) {
                this.SetAmountFields(parseInt(this.form.CurrencyId.value));
                q.showAndDisableField(this.form.PartyId);
                q.showAndDisableField(this.form.CurrencyId);
                q.showAndDisableField(this.form.ExchRate);
                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.LedgerName.value = PartyDetails.LedgerName;
                this.TaxRegistred = parseInt(PartyDetails.TaxRegType);
                this.form.GstVat.value = PartyDetails.GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
                this.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                this.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.StoneDiscount = PartyDetails.StnAddDisc == null ? 0 : PartyDetails.StnAddDisc;
                this.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.LaborDiscount = PartyDetails.LbrAddDisc == null ? 0 : PartyDetails.LbrAddDisc;
                this.ExchangeRate = this.form.ExchRate.value;

                this.form.ItemDetails.canUpdate = 0;
            }
           
        }

        protected inplaceSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                if (this.form.ItemDetails.getItems().length == 0) {
                    var grid = OMS.VendorGrid;
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Supplier"
                    });

                    pickerDialog.onSuccess = (selectedItems: OMS.VendorRow[]) => {

                        if (selectedItems.length > 0) {

                            this.form.PartyId.value = selectedItems[0].LedgerId.toString();
                            this.form.LedgerName.value = selectedItems[0].LedgerName;

                            this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                            this.form.LedgerName.value = selectedItems[0].LedgerName;
                            this.RateListId = selectedItems[0].CostPricegroupId == null ? 3 : selectedItems[0].CostPricegroupId;
                            this.StoneMarkup = selectedItems[0].StnAddMkp == null ? 0 : selectedItems[0].StnAddMkp;
                            this.LaborMarkup = selectedItems[0].LbrAddMkp == null ? 0 : selectedItems[0].LbrAddMkp;
                            this.LaborListId = selectedItems[0].LbrPricegroupId == null ? 0 : selectedItems[0].LbrPricegroupId;
                            this.StoneDiscount = selectedItems[0].StnAddDisc == null ? 0 : selectedItems[0].StnAddDisc;
                            this.LaborDiscount = selectedItems[0].LbrAddDisc == null ? 0 : selectedItems[0].LbrAddDisc;
                            if (selectedItems[0].CurrencyId > 0) {
                                this.form.CurrencyId.value = selectedItems[0].CurrencyId.toString();
                                this.SetAmountFields(selectedItems[0].CurrencyId);
                            }
                            else
                                this.form.CurrencyId.value = selectedItems[0].CurrencyId.toString();

                            var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                            this.ExchangeRate = this.form.ExchRate.value = ExchangeDetails.ExchRate;
                            this.TaxRegistred = parseInt(selectedItems[0].TaxRegType);

                            this.form.GstVat.value = selectedItems[0].GstVat;
                            let AddressDetails: OMS.AddressMasterRow;
                            OMS.AddressMasterService.GetAddress({
                                LedgerId: parseInt(this.form.PartyId.value)
                            },
                                response =>
                                    AddressDetails = response.Entity,
                                { async: false }
                            );

                            if (AddressDetails != null) {
                                this.form.State.value = AddressDetails.StateName;
                                this.form.Country.value = AddressDetails.CountryName;
                                var city = AddressDetails.CityName;
                                let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                                    + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                                this.form.Address1.value = address;

                            }
                        }
                    }
                    pickerDialog.dialogOpen();
                }
                else
                    q.Alert("Not Allowed", "Party can not be changed while items are added", 2000, false);
            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }

        SetAmountFields(value: number) {
            if (value != this.CurrencyId) {
                var CC = OMS.CurrencyMasterRow.getLookup().itemById[Q.Authorization.userDefinition.CurrencyId].CurrencyName;
                var FC = OMS.CurrencyMasterRow.getLookup().itemById[this.form.CurrencyId.value].CurrencyName;

                q.showAndDisableField(this.form.CCGrossAmount);
                q.showAndDisableField(this.form.CCNetAmount);
                q.setEditorLabel(this.form.GrossAmount, 'Total (' + FC + ')');
                q.setEditorLabel(this.form.NetAmount, 'Amount (' + FC + ')');
                q.setEditorLabel(this.form.CCGrossAmount, 'Total (' + CC + ')');
                q.setEditorLabel(this.form.CCNetAmount, 'Amount (' + CC + ')');
            }
            else {

                q.hideField(this.form.CCGrossAmount);
                q.hideField(this.form.CCNetAmount);
                q.setEditorLabel(this.form.GrossAmount, 'Total');
                q.setEditorLabel(this.form.NetAmount, 'Amount');

            }

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Purchase.Order',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            if (this.hasUpdatePermission) {
                let self = this;
                let refid: Stock.StockItemRow;
                Stock.StockItemService.CheckTransaction(
                    { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                    response => {
                        if (response.Entities != null && response.Entities.length > 0)
                            refid = response.Entities[0];
                    }, { async: false }
                )
                if (refid != null) {
                    if (refid.PartyId != null || refid.PartyId > 0) {
                        q.Alert("Can not Edit!", "This Voucher has been used in transactions", 2500, false);
                        return;
                    }
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                    this.form.ItemDetails.Editable();
                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;

                    self.updateInterface();
                    self.updateTitle();

                }
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: OrderItemsRow;
            PurchaseItemsService.ValidateReference(
                {
                    RefTransId: parseInt(this.form.TransId.value),
                    RefVoucherId: this.form.VoucherTypeId.value
                },
                response => {
                    if (response.Entities != null && response.Entities.length > 0) {
                        refid = response.Entities[0];
                    }
                }, { async: false });
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                    return;
                }
            } else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        OrderService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        }  
         

        public override validateBeforeSave() {
            var Isvalid = super.validateBeforeSave();
            var _items = this.form.ItemDetails;
            if (_items != undefined || _items != null) {
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.warning("No Items added, At least add one entry. Can not Save! ")
                    Isvalid = false;
                }
                let items = this.form.ItemDetails.getItems();
                for (var i = 0; i < items.length; i++) {
                     
                    if (items[i].BOMDetails != undefined && items[i].BOMDetails != null) {
                        items[i].BOMDetails.forEach(function (x) {
                            if (x.ProductId == null || x.ProductId.toString() == "")
                                x.ProductId = items[i].ProductId;
                            if (x.BomRate == null || q.isNumber(x.BomRate) == false || x.BomAmount == null || q.isNumber(x.BomAmount) == false || x.BomRate <= 0 || x.BomAmount <= 0) {
                                var msg = q.text('Message.Component.RateNotDefined', 'Rate not Defined for Component ' + x.ProductCode + ' in ' + items[i].ProductCode + ', Can not Save! ');
                                Q.warning(msg)
                                Isvalid = false;
                            }
                            if (x.Weight == null || x.Weight == 0) {
                                var msg = q.text('Message.Component.WeightNotDefine', 'Weight can not Zero, Can not Save! ');
                                Q.warning(msg)
                                Isvalid = false;
                            }
                        })
                    }
                    if (items[i].LaborDetails != undefined && items[i].LaborDetails != null) {
                        if (items[i].LaborDetails.length > 0) {
                            items[i].LaborDetails.forEach(function (x) {
                                if (x.LabourRate == null || q.isNumber(x.LabourRate) == false || (x.LabourAmount) == null || q.isNumber(x.LabourAmount) == false || x.LabourRate <= 0 || x.LabourAmount <= 0) {
                                    Q.warning("Rate not Defined for labor, Can not Save!")
                                    Isvalid = false;
                                }
                            })
                        }
                    }
                }

            }
            return Isvalid;

        }

    }

}